import { type FC } from "react";

import { t } from "i18n/i18n";
import { IconText } from "mds/components/IconText";
import { ToggleSwitch } from "mds/components/ToggleSwitch";
import { Tooltip } from "mds/components/Tooltip";
import { CircleInfoIcon } from "mds/icons";
import { useAppDispatch, useAppSelector } from "store/index";
import { selectIsStudentResponsesForAIEnabled } from "store/selectors";
import { aiStateActions } from "store/slices/ai";

export const StudentResponsesAllowedSwitch: FC = () => {
  const isStudentResponsesForAIEnabled = useAppSelector(selectIsStudentResponsesForAIEnabled);
  const dispatch = useAppDispatch();

  const toggleStudentResponses = () => {
    dispatch(aiStateActions.setStudentResponsesForAIEnabled(!isStudentResponsesForAIEnabled));
  };

  return (
    <ToggleSwitch
      className="body-xs w-full justify-between gap-1 py-2 pr-2"
      eventName="AI Assistant - Share student response toggle"
      isSelected={isStudentResponsesForAIEnabled}
      labelStart={
        <IconText
          className="cursor-pointer text-sm text-black-tint-40"
          iconEnd={
            <Tooltip text={t("ai.allow_responses_tooltip")}>
              <CircleInfoIcon />
            </Tooltip>
          }
          text={t("ai.allow_responses")}
        />
      }
      onClick={toggleStudentResponses}
    />
  );
};
